<div *ngIf="finished==false" class='text-center'>
  <svg width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-rolling"
    style="background: none;">
    <circle cx="50" cy="50" fill="none" stroke="#28a745" stroke-width="7" r="35"
      stroke-dasharray="164.93361431346415 56.97787143782138" transform="rotate(346.659 50 50)">
      <animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50"
        keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform>
    </circle>
  </svg>
</div>

<div *ngIf="no_recfound" class="text-center">
  {{mls?.languageText?.pharma?.key1}}<span *ngIf="mls?.is_lskey_display==1">(pharma.key1)</span>
</div>

<div *ngIf="is_res_received && no_recfound==false" class="row mt-2 cursor-pointer" (click)="navigateto()"
  [eventTracker]='{"category":"web_share","action":"click_on_pharma","product_type":product_type,"product_id":product_type_id}'>
  <div class="col-md-12 fnt-size14px">
    <div class="bg-white rounded mb-2 overflow-hidden">
      <div class="channel-header">
        <div class="channel-image-header overflow-hidden">
          <img src={{phar_detail?.powered_by}} style="height: 200px;" class="w-100 post-pic"
            onerror=" this.src='assets/img/image_placeholder.svg'" />
        </div>
        <div class="channel-heading pl-3 pr-3 clearfix position-relative">
          <div class="channel-logo p-2 mr-2 bg-white float-left" style="max-width: 116px; margin-top: -33px;">
            <img class="rounded" src={{phar_detail?.powered_by}} onerror="this.src='assets/img/user_placeholder.svg'" />
          </div>
          <div class="pl-3 pt-3 pb-3 float-left" style="word-break: break-word;">
            <p class="fnt-size18px fnt-weight500">{{phar_detail?.powered_name}}</p>
            <p>{{phar_detail?.total_channel}}</p>
            <p class="text-medium-grey">{{phar_detail?.no_of_members}}</p>
          </div>
        </div>
        <div class="channel-content p-3 border-top">
          <p class="text-medium-grey mb-2"> {{mls?.languageText?.pharma?.key2}}<span
              *ngIf="mls?.is_lskey_display==1">(pharma.key2)</span></p>
          <p>{{phar_detail?.description}}</p>
        </div>
      </div>
    </div>
    <!-- <div class="bg-white p-3 rounded mb-2">
      <app-web-channel-section></app-web-channel-section>
    </div>
    <div class="bg-white p-3 rounded mb-2">
        <app-web-channel-section></app-web-channel-section>
      </div> -->
  </div>
</div>
